import mixins from 'vue-typed-mixins';

import { CourseId } from '@/openapi/enum';

import CourseProgressMixin from '@/user/mixins/CourseProgressMixin';
import RoutesMixin from '@/user/mixins/RoutesMixin';

import { Grayout } from '@/user/components/userStamp/UserStamp';
import SectionData from '@/classes/data/SectionData';




export default mixins(CourseProgressMixin, RoutesMixin).extend({

  name: 'UnitSelectMixin',

  data(): {
    readonly courseId: CourseId;
  } {
    return {
      courseId: this.$route.params.courseId as CourseId,
    };
  },

  methods: {
    isDoneUnit(section: SectionData, unitNo: number): boolean {
      const progress = this.progresses.find(p => p.sectionNo === section.sectionNo);
      return progress !== undefined && progress.unitNos.includes(unitNo);
    },
    grayout(section: SectionData, unitNo: number): Grayout {
      return this.isDoneUnit(section, unitNo) ? Grayout.None : Grayout.Full;
    },
    toStudy(sectionNo: number, unitNo: number): void {
      this.$router.push({
        name: this.routes.Study.name,
        params: this.$route.params,
        query: {
          sectionNo: String(sectionNo),
          unitNo:    String(unitNo),
        },
      });
    },
  }

});
